/**
 * PreTGEFarming Contract ABI (UUPS Upgradeable) - V2 with zone-based distance farming
 * Auto-generated from compiled Solidity output.
 */
export const PreTGEFarmingAbi = [
	{
		"type": "constructor",
		"inputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "callbackGasLimit",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "uint32",
				"internalType": "uint32"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "cancelOwnershipHandover",
		"inputs": [],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "claimFarm",
		"inputs": [
			{
				"name": "sessionId",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "claimPoints",
		"inputs": [],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "completeOwnershipHandover",
		"inputs": [
			{
				"name": "pendingOwner",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "completeTGE",
		"inputs": [],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "conversionRate",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "getSession",
		"inputs": [
			{
				"name": "sessionId",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "tuple",
				"internalType": "struct PreTGEFarming.FarmSession",
				"components": [
					{
						"name": "farmer",
						"type": "address",
						"internalType": "address"
					},
					{
						"name": "shipTokenId",
						"type": "uint256",
						"internalType": "uint256"
					},
					{
						"name": "startedAt",
						"type": "uint64",
						"internalType": "uint64"
					},
					{
						"name": "vrfRequestId",
						"type": "uint256",
						"internalType": "uint256"
					},
					{
						"name": "resolved",
						"type": "bool",
						"internalType": "bool"
					},
					{
						"name": "outcome",
						"type": "uint8",
						"internalType": "enum FarmOutcome"
					},
					{
						"name": "systemIndex",
						"type": "uint16",
						"internalType": "uint16"
					},
					{
						"name": "zone",
						"type": "uint8",
						"internalType": "uint8"
					},
					{
						"name": "farmDuration",
						"type": "uint64",
						"internalType": "uint64"
					},
					{
						"name": "vrfDone",
						"type": "bool",
						"internalType": "bool"
					},
					{
						"name": "claimed",
						"type": "bool",
						"internalType": "bool"
					}
				]
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "getZoneDuration",
		"inputs": [
			{
				"name": "zone",
				"type": "uint8",
				"internalType": "uint8"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "getZoneRewardMultiplier",
		"inputs": [
			{
				"name": "zone",
				"type": "uint8",
				"internalType": "uint8"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "grantRoles",
		"inputs": [
			{
				"name": "user",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "roles",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "hasAllRoles",
		"inputs": [
			{
				"name": "user",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "roles",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "bool",
				"internalType": "bool"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "hasAnyRole",
		"inputs": [
			{
				"name": "user",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "roles",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "bool",
				"internalType": "bool"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "hasClaimed",
		"inputs": [
			{
				"name": "",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "bool",
				"internalType": "bool"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "initialize",
		"inputs": [
			{
				"name": "owner_",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "vrfCoordinator_",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "subscriptionId_",
				"type": "uint256",
				"internalType": "uint256"
			},
			{
				"name": "keyHash_",
				"type": "bytes32",
				"internalType": "bytes32"
			},
			{
				"name": "callbackGasLimit_",
				"type": "uint32",
				"internalType": "uint32"
			},
			{
				"name": "requestConfirmations_",
				"type": "uint16",
				"internalType": "uint16"
			},
			{
				"name": "numWords_",
				"type": "uint32",
				"internalType": "uint32"
			},
			{
				"name": "shipNFT_",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "voidToken_",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "isClaimable",
		"inputs": [
			{
				"name": "sessionId",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "bool",
				"internalType": "bool"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "isSessionActive",
		"inputs": [
			{
				"name": "sessionId",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "bool",
				"internalType": "bool"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "keyHash",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "bytes32",
				"internalType": "bytes32"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "maxFarmDuration",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "maxZone",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "minFarmDuration",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "numWords",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "uint32",
				"internalType": "uint32"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "outcomeMultiplier",
		"inputs": [
			{
				"name": "outcome",
				"type": "uint8",
				"internalType": "enum FarmOutcome"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "owner",
		"inputs": [],
		"outputs": [
			{
				"name": "result",
				"type": "address",
				"internalType": "address"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "ownershipHandoverExpiresAt",
		"inputs": [
			{
				"name": "pendingOwner",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [
			{
				"name": "result",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "points",
		"inputs": [
			{
				"name": "",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "pointsToVoid",
		"inputs": [
			{
				"name": "pointsAmount",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "proxiableUUID",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "bytes32",
				"internalType": "bytes32"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "rawFulfillRandomWords",
		"inputs": [
			{
				"name": "requestId",
				"type": "uint256",
				"internalType": "uint256"
			},
			{
				"name": "randomWords",
				"type": "uint256[]",
				"internalType": "uint256[]"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "renounceOwnership",
		"inputs": [],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "renounceRoles",
		"inputs": [
			{
				"name": "roles",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "requestConfirmations",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "uint16",
				"internalType": "uint16"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "requestOwnershipHandover",
		"inputs": [],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "revokeRoles",
		"inputs": [
			{
				"name": "user",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "roles",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "rolesOf",
		"inputs": [
			{
				"name": "user",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [
			{
				"name": "roles",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "s_vrfCoordinator",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "address",
				"internalType": "contract IVRFCoordinatorV2Plus"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "setConversionRate",
		"inputs": [
			{
				"name": "rate_",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "setCoordinator",
		"inputs": [
			{
				"name": "vrfCoordinator_",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "setDurationParams",
		"inputs": [
			{
				"name": "minDuration_",
				"type": "uint256",
				"internalType": "uint256"
			},
			{
				"name": "maxDuration_",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "setMaxZone",
		"inputs": [
			{
				"name": "maxZone_",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "setOutcomeMultiplier",
		"inputs": [
			{
				"name": "outcome",
				"type": "uint8",
				"internalType": "enum FarmOutcome"
			},
			{
				"name": "multiplierBps",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "setTierBasePoints",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"internalType": "enum ShipTier"
			},
			{
				"name": "basePoints",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "setTierBonus",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"internalType": "enum ShipTier"
			},
			{
				"name": "bonusBps",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "setTierConfig",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"internalType": "enum ShipTier"
			},
			{
				"name": "destroyedBps",
				"type": "uint16",
				"internalType": "uint16"
			},
			{
				"name": "poorBps",
				"type": "uint16",
				"internalType": "uint16"
			},
			{
				"name": "standardBps",
				"type": "uint16",
				"internalType": "uint16"
			},
			{
				"name": "richBps",
				"type": "uint16",
				"internalType": "uint16"
			},
			{
				"name": "jackpotBps",
				"type": "uint16",
				"internalType": "uint16"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "setZoneMerkleRoot",
		"inputs": [
			{
				"name": "root",
				"type": "bytes32",
				"internalType": "bytes32"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "setZoneRewardBonusBps",
		"inputs": [
			{
				"name": "bonusBps_",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "shipNFT",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "address",
				"internalType": "contract IShipNFTWithTier"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "startFarm",
		"inputs": [
			{
				"name": "shipTokenId",
				"type": "uint256",
				"internalType": "uint256"
			},
			{
				"name": "systemIndex",
				"type": "uint16",
				"internalType": "uint16"
			},
			{
				"name": "zone",
				"type": "uint8",
				"internalType": "uint8"
			},
			{
				"name": "merkleProof",
				"type": "bytes32[]",
				"internalType": "bytes32[]"
			}
		],
		"outputs": [
			{
				"name": "sessionId",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "subscriptionId",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "tgeComplete",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "bool",
				"internalType": "bool"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "tierBasePoints",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"internalType": "enum ShipTier"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "tierBonus",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"internalType": "enum ShipTier"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "tierConfig",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"internalType": "enum ShipTier"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "tuple",
				"internalType": "struct TierConfig",
				"components": [
					{
						"name": "destroyedBps",
						"type": "uint16",
						"internalType": "uint16"
					},
					{
						"name": "poorBps",
						"type": "uint16",
						"internalType": "uint16"
					},
					{
						"name": "standardBps",
						"type": "uint16",
						"internalType": "uint16"
					},
					{
						"name": "richBps",
						"type": "uint16",
						"internalType": "uint16"
					},
					{
						"name": "jackpotBps",
						"type": "uint16",
						"internalType": "uint16"
					}
				]
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "transferOwnership",
		"inputs": [
			{
				"name": "newOwner",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "upgradeToAndCall",
		"inputs": [
			{
				"name": "newImplementation",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "data",
				"type": "bytes",
				"internalType": "bytes"
			}
		],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "voidToken",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "address",
				"internalType": "address"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "zoneMerkleRoot",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "bytes32",
				"internalType": "bytes32"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "zoneRewardBonusBps",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "event",
		"name": "ConversionRateSet",
		"inputs": [
			{
				"name": "newRate",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "CoordinatorSet",
		"inputs": [
			{
				"name": "vrfCoordinator",
				"type": "address",
				"indexed": false,
				"internalType": "address"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "DurationParamsSet",
		"inputs": [
			{
				"name": "minDuration",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			},
			{
				"name": "maxDuration",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "FarmClaimed",
		"inputs": [
			{
				"name": "sessionId",
				"type": "uint256",
				"indexed": true,
				"internalType": "uint256"
			},
			{
				"name": "farmer",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			},
			{
				"name": "pointsAmount",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "FarmStarted",
		"inputs": [
			{
				"name": "sessionId",
				"type": "uint256",
				"indexed": true,
				"internalType": "uint256"
			},
			{
				"name": "farmer",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			},
			{
				"name": "shipTokenId",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			},
			{
				"name": "systemIndex",
				"type": "uint16",
				"indexed": false,
				"internalType": "uint16"
			},
			{
				"name": "zone",
				"type": "uint8",
				"indexed": false,
				"internalType": "uint8"
			},
			{
				"name": "farmDuration",
				"type": "uint64",
				"indexed": false,
				"internalType": "uint64"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "Initialized",
		"inputs": [
			{
				"name": "version",
				"type": "uint64",
				"indexed": false,
				"internalType": "uint64"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "MaxZoneSet",
		"inputs": [
			{
				"name": "maxZone_",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "OutcomeMultiplierSet",
		"inputs": [
			{
				"name": "outcome",
				"type": "uint8",
				"indexed": true,
				"internalType": "enum FarmOutcome"
			},
			{
				"name": "multiplierBps",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "OwnershipHandoverCanceled",
		"inputs": [
			{
				"name": "pendingOwner",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "OwnershipHandoverRequested",
		"inputs": [
			{
				"name": "pendingOwner",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "OwnershipTransferred",
		"inputs": [
			{
				"name": "oldOwner",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			},
			{
				"name": "newOwner",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "PointsClaimed",
		"inputs": [
			{
				"name": "user",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			},
			{
				"name": "pointsBurned",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			},
			{
				"name": "voidReceived",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "PointsEarned",
		"inputs": [
			{
				"name": "sessionId",
				"type": "uint256",
				"indexed": true,
				"internalType": "uint256"
			},
			{
				"name": "farmer",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			},
			{
				"name": "pointsAmount",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			},
			{
				"name": "outcome",
				"type": "uint8",
				"indexed": false,
				"internalType": "enum FarmOutcome"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "RandomnessFulfilled",
		"inputs": [
			{
				"name": "requestId",
				"type": "uint256",
				"indexed": true,
				"internalType": "uint256"
			},
			{
				"name": "randomWords",
				"type": "uint256[]",
				"indexed": false,
				"internalType": "uint256[]"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "RandomnessRequested",
		"inputs": [
			{
				"name": "requestId",
				"type": "uint256",
				"indexed": true,
				"internalType": "uint256"
			},
			{
				"name": "requester",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "RolesUpdated",
		"inputs": [
			{
				"name": "user",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			},
			{
				"name": "roles",
				"type": "uint256",
				"indexed": true,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "ShipDestroyed",
		"inputs": [
			{
				"name": "sessionId",
				"type": "uint256",
				"indexed": true,
				"internalType": "uint256"
			},
			{
				"name": "shipTokenId",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "TGECompleted",
		"inputs": [
			{
				"name": "conversionRate",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "TierBasePointsSet",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"indexed": true,
				"internalType": "enum ShipTier"
			},
			{
				"name": "basePoints",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "TierBonusSet",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"indexed": true,
				"internalType": "enum ShipTier"
			},
			{
				"name": "bonusBps",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "TierConfigSet",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"indexed": true,
				"internalType": "enum ShipTier"
			},
			{
				"name": "destroyedBps",
				"type": "uint16",
				"indexed": false,
				"internalType": "uint16"
			},
			{
				"name": "poorBps",
				"type": "uint16",
				"indexed": false,
				"internalType": "uint16"
			},
			{
				"name": "standardBps",
				"type": "uint16",
				"indexed": false,
				"internalType": "uint16"
			},
			{
				"name": "richBps",
				"type": "uint16",
				"indexed": false,
				"internalType": "uint16"
			},
			{
				"name": "jackpotBps",
				"type": "uint16",
				"indexed": false,
				"internalType": "uint16"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "Upgraded",
		"inputs": [
			{
				"name": "implementation",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "VRFResolved",
		"inputs": [
			{
				"name": "sessionId",
				"type": "uint256",
				"indexed": true,
				"internalType": "uint256"
			},
			{
				"name": "outcome",
				"type": "uint8",
				"indexed": false,
				"internalType": "enum FarmOutcome"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "ZoneMerkleRootSet",
		"inputs": [
			{
				"name": "root",
				"type": "bytes32",
				"indexed": false,
				"internalType": "bytes32"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "ZoneRewardBonusBpsSet",
		"inputs": [
			{
				"name": "bonusBps",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "error",
		"name": "AlreadyClaimed",
		"inputs": []
	},
	{
		"type": "error",
		"name": "AlreadyInitialized",
		"inputs": []
	},
	{
		"type": "error",
		"name": "ConversionRateNotSet",
		"inputs": []
	},
	{
		"type": "error",
		"name": "FarmNotReady",
		"inputs": []
	},
	{
		"type": "error",
		"name": "InvalidDurationParams",
		"inputs": []
	},
	{
		"type": "error",
		"name": "InvalidInitialization",
		"inputs": []
	},
	{
		"type": "error",
		"name": "InvalidTierConfig",
		"inputs": []
	},
	{
		"type": "error",
		"name": "InvalidZoneProof",
		"inputs": []
	},
	{
		"type": "error",
		"name": "NewOwnerIsZeroAddress",
		"inputs": []
	},
	{
		"type": "error",
		"name": "NoHandoverRequest",
		"inputs": []
	},
	{
		"type": "error",
		"name": "NoPointsToClaim",
		"inputs": []
	},
	{
		"type": "error",
		"name": "NotFarmer",
		"inputs": []
	},
	{
		"type": "error",
		"name": "NotInitializing",
		"inputs": []
	},
	{
		"type": "error",
		"name": "NotShipOwner",
		"inputs": []
	},
	{
		"type": "error",
		"name": "OnlyCoordinatorCanFulfill",
		"inputs": [
			{
				"name": "have",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "want",
				"type": "address",
				"internalType": "address"
			}
		]
	},
	{
		"type": "error",
		"name": "OnlyOwnerOrCoordinator",
		"inputs": [
			{
				"name": "have",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "owner",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "coordinator",
				"type": "address",
				"internalType": "address"
			}
		]
	},
	{
		"type": "error",
		"name": "SessionAlreadyClaimed",
		"inputs": []
	},
	{
		"type": "error",
		"name": "TGEAlreadyComplete",
		"inputs": []
	},
	{
		"type": "error",
		"name": "TGENotComplete",
		"inputs": []
	},
	{
		"type": "error",
		"name": "Unauthorized",
		"inputs": []
	},
	{
		"type": "error",
		"name": "UnauthorizedCallContext",
		"inputs": []
	},
	{
		"type": "error",
		"name": "UnknownRequest",
		"inputs": [
			{
				"name": "requestId",
				"type": "uint256",
				"internalType": "uint256"
			}
		]
	},
	{
		"type": "error",
		"name": "UpgradeFailed",
		"inputs": []
	},
	{
		"type": "error",
		"name": "VRFNotResolved",
		"inputs": []
	},
	{
		"type": "error",
		"name": "ZeroAddress",
		"inputs": []
	},
	{
		"type": "error",
		"name": "ZoneExceedsMax",
		"inputs": []
	},
	{
		"type": "error",
		"name": "ZoneNotConfigured",
		"inputs": []
	}
] as const;

export type PreTGEFarmingAbiType = typeof PreTGEFarmingAbi;
